import UserService from "../../services/user-service"
import { makeUserResource } from "../resources/user-resource-factory"

export const makeUserService = (): UserService => {
  return new UserService(makeUserResource())
}
